// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
    width: 100%;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    height: 100px;
    background-color: rgba(211, 213, 204);
    padding-left: 15px;
    padding-right: 15px;
}
.footer hr{
    max-width: 1000px;
    width: 100%;
    height: 1px;
    border: none;
    background-color: rgb(229, 240, 254);
}
.footer p{
    font-size: 14px;
    color: rgb(51,51,51);
    letter-spacing: 0.05em;
}`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,sBAAsB;AAC1B","sourcesContent":[".footer{\r\n    width: 100%;\r\n    margin-top: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    height: 100px;\r\n    background-color: rgba(211, 213, 204);\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n.footer hr{\r\n    max-width: 1000px;\r\n    width: 100%;\r\n    height: 1px;\r\n    border: none;\r\n    background-color: rgb(229, 240, 254);\r\n}\r\n.footer p{\r\n    font-size: 14px;\r\n    color: rgb(51,51,51);\r\n    letter-spacing: 0.05em;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
